<div class="google-geocoding" *ngIf="apiLoaded | async">
  <google-map
    [options]="options"
    [center]="{lat: this.coordinates[timezone].lat, lng: this.coordinates[timezone].lng}"
    (mapClick)="click($event)">
  </google-map>
</div>
